






































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '..';
import { TableColumnConfig, TableEntry, ColumnSortRequestData, SortedColumnInfo, ColumnsAdjustRequestData }
  from '@sonicwall/unified-ui-framework/src/shared/sw-table/types';
import UUIFComponents from '@/shared/uuifComponent';
import DefconProgress from '@/modules/msw-products/components/defcon-progress.vue';
import Vue, { CreateElement, VNode } from 'vue';
// import { SwStickProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import  { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import localForageService from '@/services/localForageUpdate.service';
const cssPrefix = 'msw_dashboard_list';
@Component({
  components: {
    ...UUIFComponents,
    DefconProgress,
  },
})

export default class DashboardListView extends SwExtendedVue{
  cssPrefix = cssPrefix;
  sortedColumns: SortedColumnInfo[] = [];
  arrayOfIndex: any = [];
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  @State((state: RootStoreState) => state.DashBoardStoreModule.filteredCustomers)
  customersDetails: DashBoardStoreState['filteredCustomers'];
  enablerenameTenentTooltip: boolean = false;
  isLoadingPartialDataset: boolean = false;
  partialData: TableEntry[] = [];
  @Watch('customersDetails') onUpdate() {
    this.partialData = this.customersDetails.slice(0, 50);
  }
  tableConfig: TableColumnConfig[] =
    [{
      key:'isStarred',
      dataKey: 'isStarred',
      title: '',
      width: 100,
      render: (createElement: CreateElement, data: { entry: TableEntry, index: number }): VNode => { // tslint:disable-line
        const element = createElement(
          'div',
          {
            style: { display: 'flex' },
          },
          [
            createElement('div', {
              class: {
                starredCustomer: true,
                tableIcon: true,
                hidden: !data.entry.isStarred,
              },
              style: { marginRight: '5px' },
              // style: { data.entry.isEnableStarred ? 'cursor: pointer' : 'cursor:default' },
              on: {
                click: () => this.revertChanges(data, false, data.entry.customerId),
              },
              directives: [
                {
                  name: 'tooltip',
                  value: {
                    content: this
                        .$t('workflow.dashboard.starredTenant')
                        .toString(),
                    compact: true,
                  },
                },
              ]}),
            createElement('div', {
              class: {
                unStarredCustomer: true,
                tableIcon: true,
                hidden: data.entry.isStarred,
              },
              style: { marginRight: '5px' },
              on: {
                click: () => this.revertChanges(data, true , data.entry.customerId),
              },
              directives: [
                {
                  name: 'tooltip',
                  value: {
                    content: this
                        .$t('workflow.dashboard.unstarredTenant')
                        .toString(),
                    compact: true,
                  },
                },
              ]}),
            createElement('div', {
              class: {
                sharedCustomer: true,
                tableIcon: true,
                hidden: data.entry.isSharedProductGroup === 'NO',
              },
              style: { marginRight: '5px' },
              directives: [
                {
                  name: 'tooltip',
                  value: { content: data.entry.sharedGroupHoverText, compact: true },
                },
              ]}),
            createElement('div', {
              class: {
                defaultCustomer: true,
                tableIcon: true,
                hidden: data.entry.isDefaultGroup !== 'TRUE',
              },
              directives: [
                {
                  name: 'tooltip',
                  value: {
                    content: this
                        .$t('workflow.dashboard.defaultTenant')
                        .toString(),
                    compact: true,
                  },
                },
              ]}),
            createElement('div', {
              class: {
                notDefaultCustomer: true,
                tableIcon: true,
                hidden: data.entry.showDefault === 'false',
              },
              on: {
                click: () => this.changeDefaultTenant(data.entry.customerId),
              },
              directives: [
                {
                  name: 'tooltip',
                  value: {
                    content: this
                        .$t('workflow.dashboard.chngDefaultTenant')
                        .toString(),
                    compact: true,
                  },
                },
              ]}),
          ],
        );
        return element;
      },
    }, {
      key: 'customerName',
      dataKey: 'customerName',
      title: this.$t('products.tenantname')
        .toString(),
      sorter: true,
      width: 200,
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => { // tslint:disable-line
        return (
        <div class="customername_col">
          <div class="customername_col_text_field">
            <span class="customername_col_text first_col_text" title={data.entry.customerName}>
            { data.entry.customerName }
            </span>
            <sw-icon class = {data.entry.canRename === 'false' ? 'hideElement' : 'customername_col_icon'} name="pencil" color="#ff791a"
                nativeOn-click={() => {
                  data.entry.customerNameBeforeEdit = data.entry.customerName;
                  this.editCustomerName(data, true);
                }
                }>
            </sw-icon>
          </div>
          <div class="customername_col_edit_text">
            <SwTextfield
              name={data.entry.customerName}
              v-tooltip={this.renameTenentTooltipValue}
              props-value = {data.entry.customerName}
              on-input={ (value: any) => this.onInputRenameTenant(value, data) }
            ></SwTextfield>
            <SwIcon class="customername_col_true_icon" props-size={14} name="checkmark" color="#99CC00"
              nativeOn-click={() => {
                this.saveEditedCustomerName(data);
                this.editCustomerName(data, false);
              }
            }></SwIcon>
            <span  style="borderRight:1px solid #C6D1DE">&nbsp;</span>
            <SwIcon class="customername_col_true_icon" props-size={12} name="close" color="#ff0000"
              nativeOn-click={() => {
                this.$store.commit('DashBoardStoreModule/renameCustomer',  { index: data.index, with: data.entry.customerNameBeforeEdit });
                this.editCustomerName(data, false);
              }
            }></SwIcon>
          </div>
          </div>
        ) as VNode;
      },
    // }, {
    //   key: 'defconAndShieldLevel',
    //   dataKey: 'defconAndShieldLevel',
    //   title: 'DEFCON AND SHIELD LEVEL',
    //   width: 240,
    //   sorter: true,
    //   render: (createElement: CreateElement, data: { entry: TableEntry }): VNode => {
    //     const element = createElement(
    //       'div',
    //       {
    //         class: { defCon_Shield_Table_Column: true },
    //       },
    //       [
    //         createElement(DefconProgress, {
    //           props: {
    //             value: data.entry.defCon,
    //           },
    //         }),
    //         createElement(SwStickProgress, {
    //           props: {
    //             value: data.entry.shield,
    //           },
    //         }),
    //       ],
    //     );
    //     return element;
    //   },
    }, {
      key: 'firewalls',
      dataKey: 'firewall',
      title: this.$t('workflow.dashboard.firewalls')
        .toString(),
      width: 120,
      sorter: true,
    }, {
      key: 'accessPoint',
      dataKey: 'accessPoint',
      sorter: true,
      width: 130,
      title: this.$t('workflow.dashboard.accessPoints')
        .toString(),
    }, {
      key: 'endpoints',
      dataKey: 'endpoints',
      sorter: true,
      width: 120,
      title: this.$t('workflow.dashboard.endPoints')
        .toString(),
    }, {
      key: 'cloudUsers',
      dataKey: 'cloudUsers',
      width: 130,
      sorter: true,
      title: this.$t('workflow.dashboard.cloudUsers')
        .toString(),
    }, {
      key: 'licensesExpiring',
      dataKey: 'licensesExpiring',
      title: this.$t('workflow.dashboard.licenceStatus')
        .toString(),
      width: 120,
      render: (
        createElement: CreateElement,
        data: { entry: TableEntry, index: number },
      ): VNode => {
        const element = createElement('div', {}, [
          createElement(
            'div',
            {
              class: {
                licenceStatus: true,
                hidden: data.entry.expiredProducts === '0',
              },
              style: { 'background-color': '#cc0000' },
              directives: [
                {
                  name: 'tooltip',
                  value: { content: `${data.entry.expiredProducts} expired licenses in last 90 days`, compact: true },
                },
              ],
            },
            [
              createElement(
                SwIcon,
                {
                  class: {
                    licenceStatusIcon: true,
                  },
                  props: {
                    name: 'info',
                    size: 'small',
                  },
                },
              ),
            ],
          ),
          createElement(
            'div',
            {
              class: {
                licenceStatus: true,
                hidden: data.entry.soonExpiringProducts === '0',
              },
              style: { 'background-color': '#FF9900' },
              directives: [{ name: 'tooltip', value : { content: `${data.entry.soonExpiringProducts} expiring ${data.entry.soonExpiringProducts > 1 ? 'products' : 'product'} within 90 days`, compact: true } }],
            },
            [
              createElement(
                SwIcon,
                {
                  class: {
                    licenceStatusIcon: true,
                  },
                  props: {
                    name: 'info',
                    size: 'small',
                  },
                },
              ),
            ],
          ),
          createElement(
            'div',
            {
              class: {
                licenceStatus: true,
                hidden: !data.entry.activeProducts || data.entry.activeProducts === '0',
              },
              style: { 'background-color': '#99cc00' },
              directives: [{ name: 'tooltip', value : { content: `${data.entry.activeProducts} ${data.entry.activeProducts > 1 ? 'products' : 'product'} with active licenses`, compact: true } }],
            },
            [
              createElement(
                SwIcon,
                {
                  class: {
                    licenceStatusIcon: true,
                  },
                  props: {
                    name: 'info',
                    size: 'small',
                  },
                },
              ),
            ],
          ),
        ]) as VNode;
        return element;
      },
    }, {
      key: 'downloadsAvailable',
      dataKey: 'downloadsAvailable',
      title: this.$t('workflow.dashboard.downloadsAvailable')
      .toString(),
      sorter: true,
    }, {
      key: 'actions',
      dataKey: 'actions',
      title: this.$t('products.actions')
      .toString(),
      width: 130,
      // fixed: true,
      render: (
        createElement: CreateElement,
        data: { entry: TableEntry, index: number },
      ): VNode => {
        const element = createElement(
          'div',
          {
            class: { action_Column: true },
          },
          [
            createElement(SwIcon, {
              props: {
                name: 'trash',
                size: 14,
              },
              class: { can_delete: data.entry.canDelete === 'true' },
              nativeOn : { click: () => this.deleteCustomer(data.index, data.entry.customerId) },
            }),
            createElement(
              'div',
              {
                class: { customer_view_detail: true },
                on: { click: () => this.goToProduct(data.entry.customerId) },
              },
              this.$t('workflow.dashboard.viewDetails')
              .toString(),
            ),
          ],
        ) as VNode;
        return element;
      },
    }];
  goToProduct(id: string) {
    console.warn(id);
    this.$router.push({ path: `/m/feature/products?tenantid=${id}` });
    window.parent.postMessage({
      redirectUrl : `/m/feature/products?tenantid=${id}`,
    },                        '*');
  }
  get renameTenentTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enablerenameTenentTooltip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.$t('workflow.dashboard.renameTenantMsg')
      .toString(),
    };
  }
  created() {
    this.buttons = [
        { key: 'cancel', name: 'Cancel', isDefault: true },
        { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: 'Confirmation',
      message: this.$t('workflow.dashboard.deleteTenantMsg')
      .toString(),
      buttons: this.buttons,
    };
    this.partialData = this.customersDetails.slice(0, 50);
    // console.warn(this.customersDetails.canRename);
  }
  onRequestColumnAdjust(data: ColumnsAdjustRequestData) {
    this.tableConfig.forEach((col) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) { return; }
      Vue.set(col, 'width', adjustInfo);
    });
  }
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
  onInputRenameTenant(value: any, data: any) {
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enablerenameTenentTooltip = true;
        return;
      }
    }
    this.$store.commit('DashBoardStoreModule/renameCustomer',  { index: data.index, with: value });
  }
  changeDefaultTenant(id: any) {
    const options: ConfirmOptions = {
      status: 'major',
      title: 'Confirmation',
      message: this.$t('workflow.dashboard.cnfrmDefaultTenantMsg')
      .toString(),
      buttons: this.buttons,
    };
    confirmService.confirm(options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        const makeDefaultGroup: any = {
          GroupId: id.toString(),
          mode: 'TENANT',
        };
        MswApiService.createCustomer.manageDefaultGroup(makeDefaultGroup)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            console.warn(resp);
            if (resp.operationStatus === 'NOK') {
              const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
            } else {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
              // this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets');
              this.$emit('updateCustomerList', { default: { customerId: makeDefaultGroup.GroupId } });
            }
          });
      }
    });
  }
  revertChanges(data: any, statusValue: boolean, productGroupId: string) {
    if (this.arrayOfIndex.length > 0) {
      const tempArr: any = [...this.arrayOfIndex];
      tempArr.forEach((index: any, number: any) => {
        const labelElement = document.getElementsByClassName('customername_col_text_field')[index] as HTMLElement;
        const textBoxElement = document.getElementsByClassName('customername_col_edit_text')[index] as HTMLElement;
        labelElement.style.display = 'flex';
        textBoxElement.style.display = 'none';
        const i = this.arrayOfIndex.indexOf(index);
        this.arrayOfIndex.splice(i, 1);
        if (number === tempArr.length - 1) this.updateStarCustomer(data, statusValue, productGroupId);
      });
    } else {
      this.updateStarCustomer(data, statusValue, productGroupId);
    }
  }
  updateStarCustomer(data: any, statusValue: boolean, productGroupId: string) {
    if (this.customersDetails[data.index].isEnableStarred) {
      const i = data.index;
      this.$store.commit('DashBoardStoreModule/updateStarCustomer', { i, statusValue });
      this.$store.commit('DashBoardStoreModule/filterCustomer', {});
      this.$store.commit('DashBoardStoreModule/sortCustomerByStar');
      const status = statusValue ? 'YES' : 'NO';
      this.$store.dispatch('DashBoardStoreModule/updateStarCustomerInDB', { productGroupId, status })
      .then((res: any) => {
        if (res.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        }
        this.$emit('updateCustomerList', { starred: { customerId: productGroupId, enable: statusValue } });
        this.$store.commit('stopLoading');
      });
    }
  }
  deleteCustomer(index: number, productGroupId: string) {
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.dispatch('DashBoardStoreModule/deleteCustomerInDB', { productGroupId })
        .then((res: any) => {
          if (res.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            this.$emit('updateCustomerList', { delete: { customerId: productGroupId } });
            this.$store.commit('DashBoardStoreModule/deleteCustomer', index);
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          }
          this.$store.commit('stopLoading');
        });
      } else {
      }
    });
  }
  editCustomerName(data:any, isEditMode: boolean) {
    console.warn(data);
    if (!this.arrayOfIndex.includes(data.index)) this.arrayOfIndex.push(data.index);
    if (data.entry.canRename === 'true') {
      const labelElement = document.getElementsByClassName('customername_col_text_field')[data.index] as HTMLElement;
      const textBoxElement = document.getElementsByClassName('customername_col_edit_text')[data.index] as HTMLElement;
      switch (isEditMode) {
        case true:
          if (labelElement) labelElement.style.display = 'none';
          if (textBoxElement) textBoxElement.style.display = 'flex';
          break;
        case false:
          if (labelElement) labelElement.style.display = 'flex';
          if (textBoxElement) textBoxElement.style.display = 'none';
          break;
      }
    }
  }
  saveEditedCustomerName(data: any) {
    if (data.entry.customerName !== '') {
      this.$store
        .dispatch('DashBoardStoreModule/renameCustomerInDB', {
          productGroupId: data.entry.customerId,
          newProductGroupName: data.entry.customerName,
          bSendMail: true,
        })
        .then((res) => {
          idb.refreshStore(PRODUCTS_STORE_NAME);
          if (res.msgCode === 'MSWAPP:UPDATEGROUPNAMESUCCESS') {
            if (this.$store.getters.isLargeCustomer) {
              Promise.all([
                this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
                MswApiService.createCustomer.getUserGroup(false),
              ])
              .then((resp: any) => {
                const newResp = localForageService.renameTenant(resp, data.entry.customerId, data.entry.customerName);
                this.saveForageData(newResp[0], '');
                this.saveForageDataForUserGroup(newResp[1], '');
                this.$emit('updateCustomerList', { edit: { customerId: data.entry.customerId, newName: data.entry.customerName } });
                this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
                this.$store.commit('stopLoading');
              });
            } else {
              this.$store.commit('stopLoading');
              this.$emit('updateCustomerList', { edit: { customerId: data.entry.customerId, newName: data.entry.customerName } });
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            }
          } else if (res.msgCode === 'MSWAPP:UPDATEGROUPNAMEFAILURE') {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.$store.commit('DashBoardStoreModule/renameCustomer',  { index: data.index, with: data.entry.customerNameBeforeEdit });
            this.$store.commit('stopLoading');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.$store.commit('stopLoading');
          }
        });
    } else {
      this.$store.commit('DashBoardStoreModule/renameCustomer',  { index: data.index, with: data.entry.customerNameBeforeEdit });
    }
  }
  saveForageData(newResponse : any , id: any) {
    MswApiService.createCustomer.saveProductsDetailList({}, newResponse)
    .then(() => {
      console.warn(id);
    });
  }
  saveForageDataForUserGroup(newResponse : any , id: any) {
    MswApiService.createCustomer.saveUserGroupList({}, newResponse)
    .then(() => {
      console.warn(id);
    });
  }
  private onLoadMore(minNumToLoad: number) {
    if (this.isLoadingPartialDataset) { return; }
    this.loadData(this.partialData.length, Math.max(minNumToLoad, 20));
  }

  private loadData(start: number, length: number) {
    if (length <= 0) { return Promise.resolve(0); }

    this.isLoadingPartialDataset = true;
    return new Promise<number>((resolve) => {
      setTimeout(
        () => {
          let count = 0;
          for (; count < length && (start + count) < this.customersDetails.length; count += 1) {
            this.partialData.push(this.customersDetails[start + count]);
          }
          this.isLoadingPartialDataset = false;
          resolve(count);
        },
        200,
      );
    });
  }
  get getPartialData() {
    this.partialData.forEach((ele : any, index : any) => {
      ele['_key'] = index.toString();
    });
    console.warn(this.partialData);
    return this.partialData;
  }
}
